import { createContext, useContext } from "react";
import { BoundarySelection } from "../../types/Boundary/BoundarySelection";
import olVectorSource from "ol/source/Vector";
import { ToolsType } from "../../constant/ToolsType";
import { BufferUnit } from "../../constant/BufferUnit";
import { Extent } from "ol/extent";

interface BoundarySelectContextType {
  vectorSource: olVectorSource;
  boundaries: BoundarySelection[];
  addBoundary: (boundary: BoundarySelection) => void;
  addBoundaries: (boundaries: BoundarySelection[]) => void;
  removeBoundary: (id: string | number) => void;
  clearBoundaries: () => void;
  selectBoundary: (id: string | number) => void;
  deselectBoundary: (id: string | number) => void;
  bufferBoundary: (
    id: string | number,
    distance: number,
    unit: BufferUnit,
  ) => void;
  activeTool: ToolsType;
  setActiveTool: (toolType: ToolsType) => void;
  drawingAreaSqKm: number | undefined;
  setDrawingAreaSqKm: (area: number | undefined) => void;
  viewExtent: Extent | undefined;
  setViewExtent: (extent: Extent) => void;
  configBoundaryId: string | number | undefined;
  setConfigBoundaryId: (id: string | number | undefined) => void;
  availableFeatureTypes: string[];
}

const BoundarySelectContext = createContext<
  BoundarySelectContextType | undefined
>(undefined);

const useBoundarySelectContext = () => {
  // get the context
  const context = useContext(BoundarySelectContext);

  // if `undefined`, throw an error
  if (context === undefined) {
    throw new Error(
      "useBoundarySelectContext was used outside of its Provider",
    );
  }

  return context;
};

export { BoundarySelectContext, useBoundarySelectContext };
